import Rule from "../Rule";

export default class RuleOAPrimaryDXRequiredToMoveFromFinalSignature extends Rule {
    static message = "Primary Diagnosis Code must be set before moving from Final Signature.";

    run() {

        const currentOrderActivity = this.currentChartData.orderActivity[this.orderActivityId];
        const futureOrderActivity = this.futureChartData.orderActivity[this.orderActivityId];

        if (this.isCashOrder(futureOrderActivity)) {
            return this.pass();
        }

        if (
            currentOrderActivity.orderStatusReasonId === 86 &&
            futureOrderActivity.status === 1 &&
            futureOrderActivity.orderStatusReasonId !== 15 && // Allow move to Verification
            futureOrderActivity.orderStatusReasonId !== 116 && // Allow move to Business Support
            !futureOrderActivity.firstDiagnosisCodeId
        ) {
            return this.fail();
        }
        else {
            return this.pass();
        }
    }

    isCashOrder(orderActivity) {
        return orderActivity?.insuranceTypeId === 4 &&
            (orderActivity?.secondaryInsuranceTypeId == null || orderActivity?.secondaryInsuranceTypeId === 4);
    }
}
